import { IFormInput } from '../views/Auth/Register/Register';
import { ApiService } from './ApiService';
import { IGetOneResponse } from '../Utilis/Types/Generic';
import { User } from '../Utilis/Types/User';
import { FieldValues } from 'react-hook-form';
export class AuthService extends ApiService {
  static pathName = '/auth';

  static login = (
    email: string,
    password: string
  ): Promise<IGetOneResponse<User>> => {
    return this.post(`${this.pathName}/login`, {
      email,
      password,
    });
  };

  static register = (body: IFormInput) => {
    return this.post(`${this.pathName}/register`, body);
  };

  static registerMember = (body: FieldValues) => {
    const formData = new FormData();

    for (const [key, value] of Object.entries(body)) {
      formData.append(key, value);
    }

    return this.post(`${this.pathName}/register/member`, formData, undefined, {
      'Content-Type': 'multipart/form-data',
    });
  };

  static getMe = (signal?: AbortSignal): Promise<IGetOneResponse<User>> => {
    return this.get(`${this.pathName}/me`, signal);
  };

  static confirmAccount = (userId: string, signal?: AbortSignal) => {
    return this.get(`${this.pathName}/confirm-account/${userId}`, signal);
  };

  static forgotPassword = (
    email: string
  ): Promise<
    IGetOneResponse<{
      message: string;
    }>
  > => {
    return this.post(`${this.pathName}/forgot-password`, { email });
  };

  static changePassword = (body: {
    id: string;
    password: string;
    confirmPassword: string;
  }): Promise<
    IGetOneResponse<{
      message: string;
    }>
  > => {
    return this.post(`${this.pathName}/reset-password`, body);
  };
  static updatePassword = (body: {
    password: string;
    confirmNewPassword: string;
    newPassword: string;
  }): Promise<
    IGetOneResponse<{
      message: string;
    }>
  > => {
    return this.post(`${this.pathName}/change-password`, body);
  };

  static requireSignUp = (body: {
    email: string;
    name: string;
    lastName: string;
  }): Promise<
    IGetOneResponse<{
      message: string;
    }>
  > => {
    return this.post(`${this.pathName}/require-signup`, body);
  };

  static accessClientView = (body: {
    clientId: string;
  }): Promise<IGetOneResponse<User>> => {
    return this.post(`${this.pathName}/client-view`, body);
  };
}
